const cricketWidgetsList = [
  {
    displayName: 'Commentary',
    name: 'commentary',
    type: 'commentary',
    gaLabel: 'commentary_tab',
  },
  {
    displayName: 'Scorecard',
    type: 'scorecard',
    name: 'scorecard',
    autoRefreshRate: '20000',
    gaLabel: 'scorecard_tab',
  },
  {
    displayName: 'INFOGRAFCRICS',
    name: 'timescricketInfografcrics',
    type: 'timescricket',
    autoLoad: false,
    gaLabel: 'timescricket_infografcrics_tab',
    data: {
      url: __PROD__
        ? 'https://timescricket.indiatimes.com/?matchid='
        : 'https://stg-timescricket.indiatimes.com/?matchid=',
    },
  },
  {
    displayName: 'Manhattan',
    name: 'manhattan',
    type: 'optaWidget',
    autoLoad: false,
    gaLabel: 'manhattan_tab',
  },
  {
    displayName: 'Match Action',
    name: 'match_action',
    type: 'optaWidget',
    autoLoad: false,
    gaLabel: 'matchAction_tab',
  },
  {
    displayName: 'Wagon Wheel',
    name: 'wagonwheel',
    type: 'optaWidget',
    autoLoad: false,
    gaLabel: 'wagonWheel_tab',
  },
  {
    displayName: 'Competition Stats',
    name: 'competition_stats',
    type: 'optaWidget',
    autoLoad: false,
    gaLabel: 'stats_tab',
  },
];

export default cricketWidgetsList;

export const inlineOptaList = [
  {
    displayName: 'Match Action',
    name: 'match_action',
    type: 'optaWidget',
    autoLoad: false,
    itemgaPrefix: 'OptaCarousel',
    gaLabel: 'matchAction_tab',
  },
  {
    displayName: 'Manhattan',
    name: 'manhattan',
    type: 'optaWidget',
    autoLoad: false,
    itemgaPrefix: 'OptaCarousel',
    gaLabel: 'manhattan_tab',
  },
  {
    displayName: 'Wagon Wheel',
    name: 'wagonwheel',
    type: 'optaWidget',
    autoLoad: false,
    itemgaPrefix: 'OptaCarousel',
    gaLabel: 'wagonWheel_tab',
  },
];
